@if (show()) {
<section
  @fadeInOut
  [id]="id()"
  class="h-dvh w-screen bg-black bg-opacity-60 flex justify-center items-center fixed top-0 left-0 z-[100] p-[6px] overflow-y-auto custom-scrollbar"
  [ngClass]="{
    'py-[80px]': !isMobile()
  }"
>
  @if (canCloseWithoutAction()) {
  <div class="h-full w-full absolute" (click)="close.emit()"></div>
  } @let hasLeftButton = leftButton() && !leftButton()?.['hide']; @let hasRightButton = rightButton() &&
  !rightButton()?.['hide']; @let hasPrimaryButton = primaryButton() && !primaryButton()?.['hide']; @let
  hasSecondaryButton = secondaryButton() && !secondaryButton()?.['hide'];

  <section
    @scaleInOut
    id="modal"
    class="z-10 w-fit overflow-hidden m-auto flex flex-col items-start gap-[16px] pt-[32px] border-radius-8 relative dropshadow-lg max-w-full"
    [ngClass]="{
      'bg-card': backgroundMode() === 'default',
      'bg-[#fcfcfc] dark:bg-[#212124]': backgroundMode() === 'access-point',
      'pb-[32px]': !isMobile() || !(footerRef() || hasLeftButton || hasRightButton || hasPrimaryButton || hasSecondaryButton || switchLabel()), 
    }"
  >
    <section
      class="flex flex-col items-start gap-[16px] max-w-full"
      [ngClass]="{
        'w-[859px]': size() === 'x-large',
        'w-[680px]': size() === 'large',
        'w-[480px]': size() === 'medium',
        'w-fit': size() === 'fit-content',
        'w-[400px]': size() === 'normal',
        'px-[24px]': isMobile(),
        'px-[32px]': !isMobile(),
      }"
    >
      @if(title() || subtitle() || headerRef()) {
      <div class="w-full max-w-full">
        @if(title() || subtitle()) {
        <div class="flex flex-col gap-[10px]">
          @if (skeleton()) {
          <lib-skeleton-loader
            [theme]="{
              'height.px': 24,
              'width.%': 50
            }"
          ></lib-skeleton-loader>
          <lib-skeleton-loader
            [theme]="{
              'height.px': 24,
              'width.%': 100
            }"
          ></lib-skeleton-loader>
          } @else { @if (title()) {
          <h2 class="text-foreground header leading-[24px]">
            {{ title() | translate }}
          </h2>
          } @if (subtitle()) {
          <p class="text-sm text-foreground-75 menu-regular">
            {{ subtitle() | translate }}
          </p>
          } }
        </div>
        } @if (headerRef()) {
        <ng-container *ngTemplateOutlet="headerRef()"></ng-container>
        }
      </div>
      } @if (canCloseWithoutAction()) {
      <div
        (click)="close.emit()"
        class="w-[40px] h-[40px] flex justify-center items-center cursor-pointer opacity-50 transition-opacity duration-200 hover:opacity-100 absolute top-[14px] right-[14px] z-10"
      >
        <i class="fi fi-rr-cross-small text-muted-foreground leading-[13px] text-[16px]"></i>
      </div>
      }
      <div class="w-full max-w-full">
        @if (contentRef()) {
        <ng-container *ngTemplateOutlet="contentRef()"></ng-container>
        } @else {
        <ng-content></ng-content>
        }
      </div>
    </section>
    @if (footerRef()) {
    <ng-container *ngTemplateOutlet="footerRef()"></ng-container>
    } @else if (hasLeftButton || hasRightButton || hasPrimaryButton || hasSecondaryButton || switchLabel()) {
    <div
      class="flex w-full min-w-fit gap-y-[16px] gap-x-[10px]"
      [ngClass]="{
        'flex-col': isMobile(),
        'px-[32px] items-center': !isMobile(),
      }"
    >
      @if (switchLabel()) {
      <lib-switch
        [ngClass]="{
          'ml-[24px]': isMobile(),
          'mr-auto': !isMobile(),
        }"
        [skeleton]="skeleton()"
        [value]="switchActive()"
        (valueChange)="switchChanged($event)"
        ><p class="text-foreground label-semibold gap-[10px] flex items-center leading-[24px]">
          <span>{{ switchLabel() | translate }}</span>
        </p></lib-switch
      >
      }
      <div
        class="flex items-center flex-1"
        [ngClass]="{
          '*:flex-1 [&>*]:rounded-none [&>*:first-child]:rounded-bl-[6px] [&>*:last-child]:rounded-br-[6px] [&>*:only-child]:rounded-b-[6px]': isMobile(),
          'justify-end gap-[10px]': !isMobile(),
        }"
      >
        @if (hasLeftButton) {
        <lib-button
          [skeleton]="skeleton()"
          id="delete-button"
          [ngClass]="{ 'pr-[64px] mr-auto': !switchLabel() && !isMobile() }"
          [loading]="leftButton()['loadingOnsignal']?.() || leftButton()['loading'] || false"
          [type]="leftButton()['type'] || 'destructive'"
          [size]="leftButton()['size'] || 'default'"
          [screen]="isMobile() ? 'mobile' : 'desktop'"
          [customClass]="isMobile() ? 'rounded-[inherit]' : ''"
          [state]="leftButton()['state'] || 'default'"
          (click)="leftButtonClick()"
          [disabled]="leftButton()['disabled'] || false"
          [icon]="leftButton()['icon']?.iconName"
          [iconAlign]="leftButton()['icon']?.direction || 'left'"
          [withoutXPadding]="isMobile()"
        >
          {{ leftButton()['label'] || 'COMPONENTS.BUTTON.DELETE' | translate }}</lib-button
        >
        } @if (hasPrimaryButton) {
        <lib-button
          [skeleton]="skeleton()"
          id="cancel-button"
          [loading]="primaryButton()['loadingOnsignal']?.() || primaryButton()['loading'] || false"
          [type]="primaryButton()['type'] || 'outline'"
          [size]="primaryButton()['size'] || 'default'"
          [screen]="isMobile() ? 'mobile' : 'desktop'"
          [customClass]="isMobile() ? 'rounded-[inherit]' : ''"
          [state]="primaryButton()['state'] || 'default'"
          (click)="cancel()"
          [disabled]="primaryButton()['disabled'] || false"
          [icon]="primaryButton()['icon']?.iconName"
          [iconAlign]="primaryButton()['icon']?.direction || 'left'"
          [withoutXPadding]="isMobile()"
        >
          {{ primaryButton()['label'] || 'COMPONENTS.BUTTON.CANCEL' | translate }}</lib-button
        >
        } @if (hasSecondaryButton) {
        <lib-button
          [skeleton]="skeleton()"
          id="confirmar-button"
          [icon]="secondaryButton()['icon']?.iconName"
          [iconAlign]="secondaryButton()['icon']?.direction || 'left'"
          [loading]="secondaryButton()['loadingOnsignal']?.() || secondaryButton()['loading'] || false"
          [type]="secondaryButton()['type'] || 'primary'"
          [size]="secondaryButton()['size'] || 'default'"
          [screen]="isMobile() ? 'mobile' : 'desktop'"
          [customClass]="isMobile() ? 'rounded-[inherit]' : ''"
          [state]="secondaryButton()['state'] || 'default'"
          (click)="confirm()"
          [disabled]="secondaryButton()['disabled'] || false"
          [withoutXPadding]="isMobile()"
        >
          {{ secondaryButton()['label'] || 'COMPONENTS.BUTTON.SAVE' | translate }}</lib-button
        >
        } @if (hasRightButton) {
        <lib-button
          [skeleton]="skeleton()"
          id="confirmar-button"
          [icon]="rightButton()['icon']?.iconName"
          [iconAlign]="rightButton()['icon']?.direction || 'left'"
          [loading]="rightButton()['loadingOnsignal']?.() || rightButton()['loading'] || false"
          [type]="rightButton()['type'] || 'primary'"
          [size]="rightButton()['size'] || 'default'"
          [screen]="isMobile() ? 'mobile' : 'desktop'"
          [customClass]="isMobile() ? 'rounded-[inherit]' : ''"
          [state]="rightButton()['state'] || 'default'"
          (click)="rightButtonClick()"
          [disabled]="rightButton()['disabled'] || false"
          [withoutXPadding]="isMobile()"
        >
          {{ rightButton()['label'] || 'COMPONENTS.BUTTON.SAVE' | translate }}</lib-button
        >
        }
      </div>
    </div>
    }
  </section>
</section>
}
